import actions from './actions'
import getters from './getters'
import types from '/src/store/types'

const state = {
  promotions: [],
  restaurants: []
}

const mutations = {
  [types.content.SET_PROMOTIONS] (state, promotions) {
    state.promotions = promotions
  },
  [types.content.SET_RESTAURANTS] (state, restaurants) {
    state.restaurants = restaurants
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/content/index.js